module.exports = __webpack_public_path__ + "img/mpqr.fbae82e0.jpg";